import React, { useEffect, useState } from 'react';
import { useAppDispatch } from 'hooks';

import { useSearch } from '~libs/searchParams';

import { ClickableIcon, Toolbar } from '~components';
import { SearchBar } from '~components/form-fields/search';
import { faMagnifyingGlass } from '~components/icon';
import { TableView } from '~components/table-view-v3';

import { columns } from '~support-at-home/forms/claims/contributionsList';
import { searchFields } from '~support-at-home/forms/claims/contributionsSearch';

import { setTitle } from '~main/actions/login';
import { getAll as getFundingTypes } from '~support-at-home/actions/fundingTypes';
import { useGetClientContributionsQuery } from '~support-at-home/actions/reconciliations';

const Contributions: React.FC<{ isActive: boolean }> = ({ isActive }) => {
  const dispatch = useAppDispatch();
  const [searchBarOpen, setSearchBarOpen] = useState<boolean>(false);
  const [searchParams, setParams] = useSearch('contributions-search', {});
  const search = (values: Record<string, any>) => setParams(values);

  useEffect(() => {
    dispatch(getFundingTypes());
    if (isActive) {
      setTitle('Contributions');
    }
  }, [isActive]);

  const { data: contributions = [], isFetching } = useGetClientContributionsQuery(searchParams);

  return (
    <div className="p-2 contributions">
      <Toolbar
        id="contributions"
        rightCluster={
          <ClickableIcon
            className="me-2"
            icon={faMagnifyingGlass}
            id="contributions-search-button"
            onClick={() => setSearchBarOpen(!searchBarOpen)}
            toolTip="Toggle Search Bar"
          />
        }
      />
      <SearchBar isOpen={searchBarOpen} fields={searchFields} initialValues={searchParams} onSubmit={search} />
      <TableView
        id="contributions-table"
        columns={columns}
        data={contributions}
        isLoading={isFetching}
        emptyMessage="No contributions found"
        readonly
        striped
      />
    </div>
  );
};

export default Contributions;
